import * as React from "react";
export type JustifyContent =
  | "flex-start"
  | "flex-end"
  | "center"
  | "space-between"
  | "space-around"
  | "space-evenly";

export type AlignItems =
  | "flex-start"
  | "flex-end"
  | "center"
  | "stretch"
  | "baseline";

interface FlexContainerProps {
  className?: string;
  justifyContent?: JustifyContent;
  alignItems?: AlignItems;
  testId?: string;
}

export const FlexContainer: React.FC<
  React.PropsWithChildren<FlexContainerProps>
> = (props) => {
  const style = {
    display: "flex",
    justifyContent: props.justifyContent ?? "flex-start",
    alignItems: props.alignItems ?? "flex-start",
  };

  return (
    <div data-testid={props.testId} className={props.className} style={style}>
      {props.children}
    </div>
  );
};
